import Swiper, {Autoplay, Pagination} from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

export default function () {
    Swiper.use([Autoplay, Pagination]);
    new Swiper('#swiper', {
        autoplay: {
            delay: 5000
        },
        grabCursor: true,
        slidesPerView: 1,
        loop: true,
        pagination: {
            el: '#carousel-pagination',
            clickable: true
        },
        // autoHeight: true,
    });
}
